var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusReprovado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "status-reprovado",
    d: "M7.5,0A7.5,7.5,0,1,0,15,7.5,7.508,7.508,0,0,0,7.5,0ZM2.641,11.446H2.624a.252.252,0,0,1-.184-.1A6.3,6.3,0,0,1,1.144,7.5,6.363,6.363,0,0,1,7.5,1.144a6.3,6.3,0,0,1,3.847,1.3.252.252,0,0,1,.025.379L2.819,11.372a.252.252,0,0,1-.178.074ZM7.5,13.856a6.3,6.3,0,0,1-3.847-1.3.252.252,0,0,1-.025-.379l8.553-8.553a.252.252,0,0,1,.379.025,6.3,6.3,0,0,1,1.3,3.847A6.363,6.363,0,0,1,7.5,13.856Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReprovado);
export default __webpack_public_path__ + "static/media/status-reprovado.d236f2ca404afd840057750d9710a0c6.svg";
export { ForwardRef as ReactComponent };